import { api } from './client'

// SmartLabWeightSettings is the frontend-safe view of the CanChe weight API
// account. The password is never returned — has_password only reports whether
// one is stored.
export interface SmartLabWeightSettings {
    enabled: boolean
    base_url: string
    username: string
    has_password: boolean
    updated_at?: string
}

export interface UpdateSmartLabWeightSettingsRequest {
    enabled: boolean
    base_url: string
    username: string
    // password: omit or leave empty to keep the stored one.
    password?: string | null
}

export const smartLabWeightSettingsApi = {
    get: () => api.get<SmartLabWeightSettings>('/smartlab/weights/settings'),
    update: (data: UpdateSmartLabWeightSettingsRequest) =>
        api.put<SmartLabWeightSettings>('/smartlab/weights/settings', data),
}
